import { render, staticRenderFns } from "./PurchaseorderRetrieved.vue?vue&type=template&id=ce841cc4&scoped=true"
import script from "./PurchaseorderRetrieved.vue?vue&type=script&lang=js"
export * from "./PurchaseorderRetrieved.vue?vue&type=script&lang=js"
import style0 from "./PurchaseorderRetrieved.vue?vue&type=style&index=0&id=ce841cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce841cc4",
  null
  
)

export default component.exports